export const environment = {
  production: true,
  BASE_URL:'https://contractor.controlfms.com/',
  encrypt_passcode : '6478'
};
